import { render, staticRenderFns } from "./DocumentUpdateContainer.vue?vue&type=template&id=a67ad376"
import script from "./DocumentUpdateContainer.vue?vue&type=script&lang=js"
export * from "./DocumentUpdateContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports